import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { AnswerType } from "../floatQuestionnaireMast";

interface IProps {
  open: boolean;
  hideDialog: () => void;
  req_ID: number;
  toast: any;
}

// const emptyEmailBody: any = {
//     to: "",
//     subject: "",
//     req: null,
//     body: "",
// }

// const schema = yup.object({
//     to: yup.string().nullable(),
//     subject: yup.string().required("Subject is required"),
//     req: yup.string().nullable(),
//     body: yup.string().nullable(),
// });

interface IFloat_Questionaires {
  id?: number;
  question?: string;
  answer_Type?: AnswerType;
  created_By?: number;
  created_On?: Date;
}

interface IFloat_Question_Answers {
  question_ID?: number;
  question?: string;
  answer?: string | null;
  answer_Type?: AnswerType;
  created_By?: number;
  created_On?: Date;
}

export const FloatQuestions = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [questions, setQuestions] = useState<Array<IFloat_Questionaires>>([]);
  const [question_Answers, setQuestion_Answers] = useState<Array<IFloat_Question_Answers>>([]);

  // const { control, handleSubmit, formState: { errors }, reset } = useForm<any>({
  //     resolver: yupResolver(schema),
  //     defaultValues: emptyEmailBody,
  //     shouldFocusError: false
  // });

  const getQuestions = async () => {
    setLoading(true);
    const response = await Fetch("Float/getQuestions", "GET", null, `reqID=${props.req_ID}`, props.toast);
    if (response) {
      const data: IFloat_Questionaires[] = await response.json();
      setQuestions(data);
      setQuestion_Answers(
        data.map((el: IFloat_Questionaires) => {
          return {
            question_ID: el.id,
            question: el.question,
            answer: null,
            answer_Type: el.answer_Type,
          };
        }),
      );
      setLoading(false);
    } else setLoading(false);
  };

  const onHide = () => {
    props.hideDialog();
  };

  const onSubmit = async () => {
    const ans = question_Answers.some((el: IFloat_Question_Answers) => {
      if (el.answer === undefined || el.answer === null || el.answer.trim() === "") return true;
      if (el.answer_Type === AnswerType.Number) {
        const num = Number(el.answer);
        return Number.isNaN(num) || num <= 0;
      }
      return false;
    });

    if (ans) {
      props.toast.current.show({ severity: "error", summary: "error", detail: "Please Answer All Questions With Valid Values", life: 3000 });
    } else {
      const newAnserData: { Question_ID: number; Answer: string }[] = question_Answers.map((el: IFloat_Question_Answers) => {
        return {
          Question_ID: el.question_ID || 0,
          Answer: el.answer || "",
          Req_ID: props.req_ID,
        };
      });

      setLoading(true);
      const response = await Fetch("Float/addQuestionAnswers", "POST", { answers: newAnserData }, null, props.toast);
      if (response) {
        props.toast.current.show({ severity: "success", summary: "success", detail: "Answers Saved Successfully", life: 3000 });
        setLoading(true);
        const response2 = await Fetch("Float/sendEmailForNoSubmissionsYet", "GET", null, `req_id=${props.req_ID}`, props.toast);
        if (response2) {
          const resp: string = await response2.text();
          props.toast.current.show({ severity: "success", summary: "success", detail: resp, life: 3000 });
          setLoading(false);
          onHide();
        } else setLoading(false);
      } else setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  useEffect(() => {
    if (props.open) {
      getQuestions();
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Requirement Float Questionnaire" modal className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit} className="p-fluid formgrid grid mt-5">
        <div className="flex flex-column gap-2 w-full">
          {question_Answers.map((ele: IFloat_Question_Answers) => (
            <Float_Question_Answers_Form el={ele} data={question_Answers} setData={setQuestion_Answers} />
          ))}
        </div>
        <div className="field col-12 md:col-12" style={{ display: "flex", gap: "10px" }}></div>
        <div style={{ margin: "10px 0", width: "100%" }}></div>
        <div className="col-12 md:col-12" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "10px" }}>
          <Button className="field col-12 md:col-6 h-2rem" loading={loading} disabled={loading} label="SAVE" type="submit"></Button>
          <Button
            className="field col-12 md:col-6 p-button-outlined"
            loading={loading}
            label="CLEAR"
            onClick={() => {
              // reset(emptyEmailBody);
            }}
            type="button"
          ></Button>
        </div>
      </form>
    </Dialog>
  );
};

const Float_Question_Answers_Form = ({ el, data, setData }: { el: IFloat_Question_Answers; data: IFloat_Question_Answers[]; setData: (nData: IFloat_Question_Answers[]) => void }) => {
  return (
    <div className="flex gap-2 p-2 align-items-center justify-content-between" style={{ border: "1px solid rgb(229, 229, 229)", marginLeft: "18px", width: "97%" }}>
      <p className="mt-2">{el.question} ? :</p>
      {/* {el.answer_Type === "Text" ? <InputText className="ml-3" style={{ width: "350px" }} id="username" value={el.answer || ""} onChange={(e) => {
                let newData: IFloat_Question_Answers[] = data.map((ele: IFloat_Question_Answers) => {
                    if (ele.question_ID === el.question_ID) return { ...ele, answer: e.target.value };
                    else return ele;
                });
                setData(newData);
            }} /> :
                (<div className="flex flex-wrap gap-3 ml-3">
                    <div className="flex align-items-center">
                        <RadioButton inputId="Yes" name="answer" value="Yes" onChange={(e) => {
                            let newData: IFloat_Question_Answers[] = data.map((ele: IFloat_Question_Answers) => {
                                if (ele.question_ID === el.question_ID) return { ...ele, answer: e.value };
                                else return ele;
                            });
                            setData(newData);
                        }} checked={el.answer === 'Yes'} />
                        <label htmlFor="Yes" className="ml-2">Yes</label>
                    </div>
                    <div className="flex align-items-center">
                        <RadioButton inputId="No" name="answer" value="No" onChange={(e) => {
                            let newData: IFloat_Question_Answers[] = data.map((ele: IFloat_Question_Answers) => {
                                if (ele.question_ID === el.question_ID) return { ...ele, answer: e.value };
                                else return ele;
                            });
                            setData(newData);
                        }} checked={el.answer === 'No'} />
                        <label htmlFor="No" className="ml-2">No</label>
                    </div>
                </div>)} */}

      {el.answer_Type === AnswerType.Text ? (
        <InputText
          className="ml-3"
          style={{ width: "350px" }}
          value={el.answer || ""}
          onChange={(e) => {
            const newData = data.map((ele) => (ele.question_ID === el.question_ID ? { ...ele, answer: e.target.value } : ele));
            setData(newData);
          }}
        />
      ) : el.answer_Type === AnswerType.Number ? (
        <InputText
          className="ml-3"
          style={{ width: "350px" }}
          keyfilter="pint"
          value={el.answer || ""}
          onChange={(e) => {
            let digitsOnly = e.target.value.replace(/\D/g, "");
            digitsOnly = digitsOnly.replace(/^0+(?=\d)/, "");
            const newData = data.map((ele) => (ele.question_ID === el.question_ID ? { ...ele, answer: digitsOnly } : ele));
            setData(newData);
          }}
        />
      ) : (
        <div className="flex flex-wrap gap-3 ml-3">
          <div className="flex align-items-center">
            <RadioButton
              inputId={`yes-${el.question_ID}`}
              name={`answer-${el.question_ID}`}
              value="Yes"
              onChange={(e) => {
                const newData = data.map((ele) => (ele.question_ID === el.question_ID ? { ...ele, answer: e.value } : ele));
                setData(newData);
              }}
              checked={el.answer === "Yes"}
            />
            <label htmlFor={`yes-${el.question_ID}`} className="ml-2">
              Yes
            </label>
          </div>

          <div className="flex align-items-center">
            <RadioButton
              inputId={`no-${el.question_ID}`}
              name={`answer-${el.question_ID}`}
              value="No"
              onChange={(e) => {
                const newData = data.map((ele) => (ele.question_ID === el.question_ID ? { ...ele, answer: e.value } : ele));
                setData(newData);
              }}
              checked={el.answer === "No"}
            />
            <label htmlFor={`no-${el.question_ID}`} className="ml-2">
              No
            </label>
          </div>
        </div>
      )}
    </div>
  );
};
